<script>
export default {
  props: {
    iconPath: {
      type: String,
      required: true
    },
    tooltipMessage: {
      type: String,
      required: true
    },
    sugestion: {
      type: Boolean,
      required: false,
      default: false
    }
  }
};
</script>

<template>
  <div class="hidden-tip" :class="{inverted: sugestion}" :attr="tooltipMessage" @click.stop>
    <img :src="iconPath" />
  </div>
</template>

<style scoped>
img {
  width: 24px;
  height: 24px;
  padding-right: 4px;
}

.hidden-tip {
  transition: all 0.4s ease;
  -webkit-transition: all 0.4s ease;
}

.inverted {
  filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(85deg)
    brightness(108%) contrast(101%);
}

.hidden-tip:before {
  z-index: 1;
  content: attr(attr);
  background-color: #424242;
  color: #fff;
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;
  box-sizing: border-box;
  font-family: "Roboto";
  position: absolute;
  right: 0;
  bottom: -20px;
  max-width: 320px;
  width: fit-content;
  opacity: 0;
  transition: all 0.4s ease;
}

.hidden-tip:hover:after,
.hidden-tip:hover:before {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Components/Scheduler/Steps/ProfessionalList/Card/Badge.vue